module.exports = __webpack_public_path__ + "img/icon-toggle-ko.1dbbb546.svg";